import {MatPaginatorIntl} from '@angular/material/paginator';
import {Injectable} from "@angular/core";

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  override itemsPerPageLabel = $localize`:@@itemsPerPageLabel:Items per page` + ":";
  override nextPageLabel = $localize`:@@nextPageLabel:Next page`;
  override previousPageLabel = $localize`:@@previousPageLabel:Previous page`;
  override firstPageLabel = $localize`:@@firstPageLabel:First page`;
  override lastPageLabel = $localize`:@@lastPageLabel:Last page`;

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return $localize`:@@rangePageLabelZero:0 / ${length}`;
    }
    const startIndex = page * pageSize + 1;
    const endIndex = Math.min(startIndex + pageSize - 1, length);
    return $localize`:@@rangePageLabel:${startIndex} – ${endIndex} / ${length}`;
  };
}
